import RequestWrapper from 'e-submission/domain/data/request-wrapper'

export default {
  getRequest: (path, user, params, config = {}) => RequestWrapper.getRequest(path, user, params, config),
  postRequest: (path, user, data) => RequestWrapper.postRequest(path, user, data),
}
